import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';

export const Title = styled(Text)`
  margin: 0;
  margin-bottom: ${spacing.space16};
`;

export const Ingress = styled(Text)`
  margin: 0;
  margin-bottom: ${spacing.space16};
`;

export const Container = styled.div<{ $variant?: string; $onlyTitles?: boolean; $listType?: string }>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.space32};

  * > a {
    color: ${colors.secondary[500]};
  }

  ol {
    list-style: none;
    counter-reset: item;
    padding-top: ${({ $listType }) => ($listType === 'plain' ? '0' : `${spacing.space48}`)};
    margin-left: 0;
    padding-left: ${({ $listType }) => ($listType === 'plain' ? '0' : '60px')};
    margin-bottom: -${spacing.space48};
    max-width: 550px;
  }

  li {
    counter-increment: item;
    position: relative;
    margin-bottom: ${({ $onlyTitles }) => ($onlyTitles ? '35px' : '24px')};

    p {
      position: relative;
      top: ${({ $listType }) => ($listType === 'plain' ? '0' : '-36px')};
      vertical-align: middle;
      display: inline-block;
    }
  }

  li:before {
    position: absolute;
    left: -59px;
    top: -41.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ $listType }) => $listType === 'plain' && 'display: none;'}
    height: 38px;
    width: 38px;
    border-radius: ${spacing.space20};
    margin-right: 10px;
    margin-bottom: ${spacing.space8};
    content: counter(item);
    color: ${colors.secondary[900]};
    text-align: center;
    font-weight: 500;

    ${({ $variant }) =>
      $variant === 'outline' &&
      `
      background: ${nafColor.signature.white};
      border: 1px solid black;
    `}

    ${({ $variant }) =>
      $variant === 'secondary' &&
      `
      background: ${colors.secondary[100]};
    `}
  }

  li:last-child {
    ${({ $listType }) => $listType === 'plain' && `margin-bottom: ${spacing.space40};`}
  }

  li:not(:last-child):after {
    ${({ $listType }) => $listType === 'plain' && 'display: none;'}
    content: '';
    position: absolute;
    left: -41px;
    top: -5px;
    bottom: 0;
    height: calc(100% - 5px);
    width: 3px;
    background-image: linear-gradient(to bottom, ${colors.secondary[900]} 33%, rgba(255, 255, 255, 0) 0%);
    background-size: 3px 10px;
    background-repeat: repeat-y;
    z-index: -1;
  }
`;

export const Step = styled(Text)`
  margin: 0;
  font-weight: 700;
  font-size: 1.125rem;
`;

export const ListContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BodyWrapper = styled.div<{ $listType?: string }>`
  p {
    position: relative;
    top: ${({ $listType }) => ($listType === 'plain' ? '0' : '-50px')};
    vertical-align: middle;
    display: inline-block;
    margin-top: 0;
  }
`;
